import {
  CustomFormattedMessage,
  CustomFormattedMessageProps,
  TranslationsKeys,
} from '../../i18n/i18n';
import { ReactNode } from 'react';
import classNames from 'classnames';

type SidebarRowProps = {
  label: TranslationsKeys;
  labelValues?: CustomFormattedMessageProps['values'];
  show?: boolean;
  highlightLabel?: boolean;
  fadeValue?: boolean;
  children?: ReactNode;
};

export const SidebarRow = ({
  label,
  labelValues,
  show = true,
  highlightLabel = false,
  fadeValue = false,
  children,
}: SidebarRowProps) => {
  if (!show) {
    return <></>;
  }

  return (
    <tr>
      <td
        className={classNames(
          highlightLabel ? 'text-color-black text-medium' : 'text-color-gray',
        )}
      >
        <CustomFormattedMessage
          id={label}
          values={labelValues}
        />
      </td>
      <td
        className={classNames('text-right', {
          'text-color-gray': fadeValue,
        })}
        style={{ wordBreak: 'break-word' }}
      >
        {children}
      </td>
    </tr>
  );
};
